// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","passwordSettings":"n2LUX8DsDzM0g1B0_neD","saveButton":"sVBlr4e9m2g2AYcS0SDP","hint":"YT03wgJcoSReKoD_JhoQ"};